import React, { Fragment, useContext, useEffect, useState } from "react";
import UnregActionMenu from "../layout/UnregActionMenu";
import AuthContext from "../../context/auth/AuthContext";
import CardContext from "../../context/card/CardContext";
import CartContext from "../../context/cart/CartContext";
import "./OrderConfirmation.css";
import usePageTitle from "../../hooks/usePageTitle";

const OrderConfirmation = (props) => {
  // const cartContext = useContext(CartContext);
  const authContext = useContext(AuthContext);
  const cardContext = useContext(CardContext);
  const cartContext = useContext(CartContext);
  const { completedOrder, resetCardState, error: cardError } = cardContext;
  const { resetCartState, error: cartError } = cartContext;
  const { user } = authContext;

  const [successOrder, setSuccessOrder] = useState("");

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Order Confirmation",
  });

  useEffect(() => {
    if (!cardError && !cartError) {
      resetCardState();
      resetCartState();
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (completedOrder) {
      setSuccessOrder(completedOrder);
    }
    //eslint-disable-next-line
  }, [completedOrder]);

  return (
    <Fragment>
      <UnregActionMenu />
      <div
        className="privateView confirmOrder"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="confirmOrder__title">
          <div className="confirmOrder__title__image">
            <i className="fas fa-check fa-2x circle-icon confirmOrder__title__icon"></i>
          </div>
          <div className="confirmOrder__title__message">Order Success</div>
          <div>Your Order has been placed</div>
        </div>
        <div className="confirmOrder__orderSummary">
          <div className="confirmOrder__orderSummary__subTitle">
            Your Order Number is
          </div>
          {successOrder && (
            <div className="patronConfirmOrder__orderSummary__orderDetail">
              {successOrder}
            </div>
          )}
        </div>
        <div className="confirmOrder__orderInfo">
          {/* <div>
            You will receive an email confirmation shortly to{" "}
            <span className="confirmOrder__orderInfo__email">{user.email}</span>
          </div> */}
          <div>
            {" "}
            We estimate your order should be complete 2-4 business working days
          </div>
        </div>
        <div className="confirmOrder__footNote">
          For any concerns please reach out to qexpire@ridemetro.org
        </div>
      </div>
    </Fragment>
  );
};

export default OrderConfirmation;
